<template>
    <div>
        <label :for="input.name" :title="input.title">
            {{ input.label }}
            <i  v-if="input.title"
                :ref="`${input.name}-label`"
                class="fal fa-question-circle text-grey-600"
            ></i>
        </label>
        <b-tooltip v-if="input.title" :target="() => $refs[`${input.name}-label`]" placement="right">
            {{ input.title }}
        </b-tooltip>
        <input
            class="form-control"
            :class="{ 'border-red bg-red-100': hasError }"

            :name="input.name"
            :type="input.type"
            v-model="input.value"
            :placeholder="input.placeholder"
            :required="input.validation.includes('required')"
        />
        <input-errors :error-messages="input.errors"></input-errors>
    </div>
</template>

<script>
import common from './common';

export default {
    mixins: [common],
}
</script>
